import {theme} from "../../../../../utils";

export const styles = {
    itemListWrapper: {
        borderBottom: "1px solid #4B69F1",
        pb: "28px",
        pt: "43px"
    },
    listTitle: {
        ...theme.typography.montseratH1,
        fontSize: "19.94px",
        color: "#1E1E22",
        flex: 1
    },
    downloadLabel: {
        ...theme.typography.montseratBodyRegular,
        fontSize: "16.31px",
        color: theme.palette.primary.main,
        textTransform: "capitalize"
    },
    mobileWrapper: {
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start"
    }
}